export default __webpack_public_path__ + "static/media/fast-icon.f52fb5cc.svg";